import Otp from "./Otp";
import { errorMessage, question, userType } from "config/app.constant";
import { regexValidation } from "utils/regexValidation";
import Captcha from "./Captcha";
import Contact from "./Contact";

const steps = [
    {
        id: "welcomeQuestion",
        message: question.WELCOME,
        trigger: "userSelection",
    },
    {
        id: "userSelection",
        options: [
            { value: userType.JOB_SEEKER, label: "I am a Job-Seeker", trigger: "js" },
            { value: userType.EMPLOYER, label: "I am an Employer", trigger: "emp" },
        ],
    },
    {
        id: "js",
        message: question.GREET_JOB_SEEKER,
        trigger: "question4",
    },
    {
        id: "emp",
        message: question.GREET_EMPLOYER,
        trigger: "question4",
    },
    {
        id: "question4",
        options: [
            { value: "signup", label: "Registration", trigger: "signup" },
            { value: 1, label: "Customer Support ", trigger: "queryName" },
            { value: 0, label: "Feedback", trigger: "feedbackName" },
        ],
    },
    {
        id: "signup",
        message: question.ENTER_PHONE,
        trigger: "contactNumber",
    },
    {
        id: "contactNumber",
        user: true,
        validator: (value) => {
            if (regexValidation.PHONE.test(value)) {
                return true;
            } else {
                return errorMessage.INVALID_PHONE
            }
        },
        trigger: "otp",
    },
    {
        id: "otp",
        component: <Contact />,
        asMessage: true,
        trigger: "enterOtp",
    },
    {
        id: "enterOtp",
        user: true,
        validator: (value) => {
            if (regexValidation.OTP.test(value)) {
                return true;
            } else {
                return errorMessage.INVALID_OTP;
            }
        },
        trigger: "verifyotp",
    },
    {
        id: "verifyotp",
        component: <Otp />,
        end: true,
        asMessage: true,
    },
    {
        id: "queryName",
        message: question.ENTER_NAME,
        trigger: "submitQueryName",
    },
    {
        id: "submitQueryName",
        user: true,
        validator: (value) => {
            if (regexValidation.FULL_NAME.test(value)) {
                return true;
            } else {
                return errorMessage.INVALID_NAME;
            }
        },
        trigger: "queryContact",
    },
    {
        id: "queryContact",
        message: question.ENTER_PHONE,
        trigger: "submitQueryContact",
    },
    {
        id: "submitQueryContact",
        user: true,
        validator: (value) => {
            if (regexValidation.PHONE.test(value)) {
                return true;
            } else {
                return errorMessage.INVALID_PHONE
            }
        },
        trigger: "query",
    },
    {
        id: "feedbackName",
        message: question.ENTER_NAME,
        trigger: "submitFeedbackName",
    },
    {
        id: "submitFeedbackName",
        user: true,
        validator: (value) => {
            if (regexValidation.FULL_NAME.test(value)) {
                return true;
            } else {
                return errorMessage.INVALID_NAME;
            }
        },
        trigger: "feedbackContact",
    },
    {
        id: "feedbackContact",
        message: question.ENTER_PHONE,
        trigger: "submitFeedbackContact",
    },
    {
        id: "submitFeedbackContact",
        user: true,
        validator: (value) => {
            if (regexValidation.PHONE.test(value)) {
                return true;
            } else {
                return errorMessage.INVALID_PHONE
            }
        },
        trigger: "review",
    },
    {
        id: "query",
        message: question.ENTER_QUERY,
        trigger: "submitQuery",
    },
    {
        id: "submitQuery",
        user: true,
        validator: (value) => {
            if (value && value.length >= 5) {
                return true;
            } else {
                return errorMessage.MIN_QUERY_LENGTH
            }
        },
        trigger: "openCaptcha",
    },
    {
        id: "review",
        message: question.ENTER_REVIEW,
        trigger: "submitReview",
    },
    {
        id: "submitReview",
        user: true,
        validator: (value) => {
            if (regexValidation.RATING.test(value)) {
                return true;
            } else {
                return errorMessage.INVALID_RATINGS;
            }
        },
        trigger: "openCaptcha",
    },
    {
        id: "openCaptcha",
        component: <Captcha />,
        asMessage: true,
        end: true
    },
];

export default steps;